<template>
  <b-modal v-model="modalAberto" size="xl" @hidden="cancelar" @close="cancelar" button-size="md" hide-footer
    :title="prefix + title">
    <ConsultaProdutosList :almoxarifado="almoxarifado" :departamento="departamento" @onselect="produtoSelect"
      :tipoOperacao="tipoOperacao" />
  </b-modal>
</template>

<script>
import ConsultaProdutosList from "@/modules/almoxarifados/consulta-produtos/ConsultaProdutosList.vue"
import TipoOperacaoAlmoxarifadoProdutoEnum from "@/core/utils/TipoOperacaoAlmoxarifadoProdutoEnum"

export default {
  name: "ConsultaProdutoList",
  components: {
    ConsultaProdutosList,
  },
  props: {
    almoxarifado: {
      type: Number,
      default: null,
    },
    id: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Produtos do Almoxarifado ",
    },
    prefix: {
      type: String,
      default: "",
    },
    departamento: {
      type: Object,
      default: undefined,
    },
    tipoOperacao: {
      type: TipoOperacaoAlmoxarifadoProdutoEnum,
      default: TipoOperacaoAlmoxarifadoProdutoEnum.CONSULTA,
    },
  },
  data() {
    return {
      modalAberto: true,
    }
  },
  methods: {
    cancelar() {
      this.modalAberto = false
      this.$emit("close")
    },

    produtoSelect(produto) {
      this.$emit("onselect", produto)
      this.cancelar()
    },
  },
}
</script>
